import React from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import Helmet from 'react-helmet'


const CorporateProgramEs = () => (
  <div className="page corporate_program" >
  <Helmet
          title={`Nicaragua Programa Corporativo Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href: './en/corporate_program',
            },
          ]}
        />
   <div className="image"></div>
    <h1>Programa Corporativo</h1>
    <h2>Tenemos el vehículo que se adapta a las necesidades de tu negocio.</h2>
    <h3>Nuestro programa corporativo ofrece beneficios exclusivos para afiliados:</h3>
    <div>
      <div>  
        <ul>
          <li>
          Tarifas especiales
          </li>
          <li>
          Crédito corporativo
          </li>
          <li>
          Atención personalizada con un ejecutivo dedicado a su cuenta
          </li>
          <li>
          Atención personalizada
          </li>
          <li>
          Aprobación de crédito inmediato
          </li>
          <li>
          tarifas fijas durante todo el año.
          </li>
          <li>
          Servicio a domicilio sin costo adicional (aplican restricciones)
          </li>
          <li>
          Conductor adicional sin costo.
          </li>
          <li>
          Exoneración de cargo de Aeropuerto.
          </li>
          <li>
          Programa de renta mensual (aplican restricciones)
          </li>
          <li>
          Descuentos para sus colaboradores. 
          </li>
          
        </ul>

        <p>
        ¡La mejor opción para tu empresa!<br/>
        Contáctanos para obtener la mejor solución 
        de transporte para tu empresa, con la calidad, el servicio y la confianza que solo Budget te puede ofrecer. 
        </p>

        <div>  
        <a href="mailto:negocios@budget.com.ni" className="btn">
          Contáctenos
        </a>
      </div>

      </div>
    </div>
    
  </div>
)
export default CorporateProgramEs




// WEBPACK FOOTER //
// ./src/pages/corporate_program.es.js